<script>
export default {
  name: "CoinBit",

  props: {
    part: {
      type: String,
      default: 'top',
      required: false
    },

    amount: {
      type: Number,
      default: 1,
      required: false
    },

    cssClass: {
      type: String,
      default: '',
      required: false
    },
  },
};
</script>

<template>
  <div
    :class="'stack-' + part + ' ' + cssClass"
    v-for="index in amount"
    :key="index"
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 44" v-if="part === 'top'" v-bind:svg-inline="''" :class="'coin-' + part" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path class="coin-top" d="M45.008.284C20.273.284.111 7.144.111 15.666v12.679a8.84 8.84 0 00.414 2.286c1.035 2.494 3.741 4.573 7.483 6.443.744.384 1.507.729 2.286 1.034.827.414 1.663.62 2.702 1.035 8.106 2.91 19.538 4.573 32.01 4.573 12.678 0 23.902-1.872 32.009-4.573.827-.414 1.87-.621 2.701-1.035.831-.414 1.456-.62 2.286-1.034 3.95-1.871 6.443-4.157 7.483-6.443a7.472 7.472 0 00.414-2.286v-12.68C89.905 7.144 69.743.286 45.009.286zm7.69 19.539a13.343 13.343 0 01-4.987 1.252v1.862h-4.156v-1.862a25.468 25.468 0 01-3.95-.413 30.297 30.297 0 01-3.533-.828l2.702-1.871c1.011.372 2.055.65 3.118.827 1.03.173 2.074.242 3.117.207a9.38 9.38 0 002.702-.207c.62-.207.827-.413.827-1.034 0-.414-.206-.62-.827-.828s-1.247-.413-2.08-.62c-.83-.207-1.87-.414-2.7-.62a55.999 55.999 0 01-2.703-.621 4.873 4.873 0 01-2.079-1.035 1.57 1.57 0 01-.827-1.455 2.914 2.914 0 011.663-2.286 10.192 10.192 0 014.78-1.034V7.35h4.158v1.871a10.07 10.07 0 013.741.621 12.02 12.02 0 012.91 1.034l-3.741 1.456a9.37 9.37 0 00-2.286-.62 8.565 8.565 0 00-2.494-.208 6.464 6.464 0 00-2.286.207c-.62.207-.828.414-.828.828 0 .207.207.62.828.827s1.247.414 2.079.62c.832.208 1.871.415 2.702.621a56 56 0 012.702.621c.766.172 1.48.527 2.079 1.034.533.286.855.852.827 1.456.206.65-.418 1.48-1.457 2.104z"/></svg>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 25" v-else="" v-bind:svg-inline="''" :class="'coin-' + part" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path class="coin-side" d="M8.189 18.311c.742.383 1.503.728 2.28 1.032.826.413 1.66.62 2.696 1.032 8.087 2.903 19.492 4.563 31.935 4.563 12.65 0 23.847-1.867 31.934-4.563.826-.412 1.867-.619 2.696-1.032.829-.412 1.452-.619 2.28-1.032 3.94-1.866 6.429-4.147 7.466-6.428a7.454 7.454 0 00.412-2.28V.063a23.947 23.947 0 01-4.147 3.11c-.62.412-1.245.619-1.867 1.032-.622.412-1.452.619-2.073 1.032-9.332 4.147-23.225 6.221-36.912 6.221S17.31 9.385 7.977 5.237a19.268 19.268 0 01-2.074-1.032c-.62-.207-1.032-.62-1.66-.826A35.965 35.965 0 01.102.27V9.6a8.82 8.82 0 00.413 2.28c1.04 2.283 3.735 4.564 7.675 6.43z"/></svg>
  </div>
</template>
